import React from "react";

export const StatusBadge: React.FC<{ isResolved: boolean | null | undefined }> = ({
  isResolved,
}) => {
  if (isResolved === null || isResolved === undefined) {
    return (
      <span className="al-px-2 al-py-0.5 al-rounded al-text-xs al-bg-gray-100 al-text-gray-600">
        Unknown
      </span>
    );
  }
  return isResolved ? (
    <span className="al-px-2 al-py-0.5 al-rounded al-text-xs al-bg-green-100 al-text-green-700">
      Resolved
    </span>
  ) : (
    <span className="al-px-2 al-py-0.5 al-rounded al-text-xs al-bg-red-100 al-text-red-700">
      Failed
    </span>
  );
};
